const ROLE_KEYS = Object.freeze({
  PLATFORM_ADMIN: 'platform_admin',
  OWNER_ADMIN: 'owner_admin',
  DOCTOR: 'doctor',
  STAFF: 'staff',
  ACCOUNTANT: 'accountant',
  CONSULTANT_DOCTOR: 'consultant_doctor',
});

const ROLE_ALIASES = Object.freeze({
  platform_admin: ROLE_KEYS.PLATFORM_ADMIN,
  platformadmin: ROLE_KEYS.PLATFORM_ADMIN,
  super_admin: ROLE_KEYS.PLATFORM_ADMIN,

  doctor_admin: ROLE_KEYS.OWNER_ADMIN,
  admin_doctor: ROLE_KEYS.OWNER_ADMIN,
  clinic_owner: ROLE_KEYS.OWNER_ADMIN,
  owner: ROLE_KEYS.OWNER_ADMIN,
  admin: ROLE_KEYS.OWNER_ADMIN,

  doctor: ROLE_KEYS.DOCTOR,
  clinician: ROLE_KEYS.DOCTOR,

  staff: ROLE_KEYS.STAFF,
  front_desk: ROLE_KEYS.STAFF,
  frontdesk: ROLE_KEYS.STAFF,
  receptionist: ROLE_KEYS.STAFF,

  accountant: ROLE_KEYS.ACCOUNTANT,
  finance: ROLE_KEYS.ACCOUNTANT,
  finance_user: ROLE_KEYS.ACCOUNTANT,

  consultant: ROLE_KEYS.CONSULTANT_DOCTOR,
  consultant_doctor: ROLE_KEYS.CONSULTANT_DOCTOR,
});

export function normalizeRole(role) {
  const key = String(role || '').trim().toLowerCase();
  return ROLE_ALIASES[key] || key || null;
}

export function isOwnerAdminRole(role) {
  return normalizeRole(role) === ROLE_KEYS.OWNER_ADMIN;
}

export function isPlatformAdminRole(role) {
  return normalizeRole(role) === ROLE_KEYS.PLATFORM_ADMIN;
}

export function hasFinanceRole(role) {
  const normalizedRole = normalizeRole(role);
  return [ROLE_KEYS.OWNER_ADMIN, ROLE_KEYS.ACCOUNTANT].includes(normalizedRole);
}

export function hasAttendanceAccess(role) {
  const normalizedRole = normalizeRole(role);
  return [ROLE_KEYS.OWNER_ADMIN, ROLE_KEYS.DOCTOR, ROLE_KEYS.STAFF].includes(normalizedRole);
}

export function canManageTeamAttendance(role) {
  const normalizedRole = normalizeRole(role);
  return [ROLE_KEYS.OWNER_ADMIN, ROLE_KEYS.DOCTOR].includes(normalizedRole);
}

export function canCorrectAttendance(role) {
  return normalizeRole(role) === ROLE_KEYS.OWNER_ADMIN;
}

export function canManageDoctorCircleProfile(role) {
  const normalizedRole = normalizeRole(role);
  return [ROLE_KEYS.OWNER_ADMIN, ROLE_KEYS.DOCTOR, ROLE_KEYS.CONSULTANT_DOCTOR].includes(normalizedRole);
}

export function canSearchDoctorCircleProfiles(role) {
  const normalizedRole = normalizeRole(role);
  return [
    ROLE_KEYS.OWNER_ADMIN,
    ROLE_KEYS.DOCTOR,
    ROLE_KEYS.STAFF,
    ROLE_KEYS.ACCOUNTANT,
    ROLE_KEYS.CONSULTANT_DOCTOR,
    ROLE_KEYS.PLATFORM_ADMIN,
  ].includes(normalizedRole);
}

export function canBrowseSupplyHubMarketplace(role) {
  const normalizedRole = normalizeRole(role);
  return [
    ROLE_KEYS.OWNER_ADMIN,
    ROLE_KEYS.DOCTOR,
    ROLE_KEYS.STAFF,
    ROLE_KEYS.ACCOUNTANT,
    ROLE_KEYS.PLATFORM_ADMIN,
  ].includes(normalizedRole);
}

export function canViewSupplyHubRecommendations(role) {
  const normalizedRole = normalizeRole(role);
  return [
    ROLE_KEYS.OWNER_ADMIN,
    ROLE_KEYS.DOCTOR,
    ROLE_KEYS.STAFF,
    ROLE_KEYS.ACCOUNTANT,
  ].includes(normalizedRole);
}

export function canManageSupplyHubRecommendations(role) {
  const normalizedRole = normalizeRole(role);
  return [
    ROLE_KEYS.OWNER_ADMIN,
    ROLE_KEYS.DOCTOR,
  ].includes(normalizedRole);
}

export function canCreateSupplyHubOrders(role) {
  const normalizedRole = normalizeRole(role);
  return [
    ROLE_KEYS.OWNER_ADMIN,
    ROLE_KEYS.DOCTOR,
  ].includes(normalizedRole);
}

export function canViewSupplyHubOrders(role) {
  const normalizedRole = normalizeRole(role);
  return [
    ROLE_KEYS.OWNER_ADMIN,
    ROLE_KEYS.DOCTOR,
    ROLE_KEYS.STAFF,
    ROLE_KEYS.ACCOUNTANT,
  ].includes(normalizedRole);
}

export function canManageSupplyHubOrders(role) {
  const normalizedRole = normalizeRole(role);
  return [
    ROLE_KEYS.OWNER_ADMIN,
    ROLE_KEYS.DOCTOR,
  ].includes(normalizedRole);
}

export { ROLE_KEYS };
